import { Panel } from '@/components/Panel';
import { useDispatches } from '@/hooks/useDispatches';
import { EmptyState, Spinner } from '@00start/ui';
import { formatTime } from '@/utils/chart-helpers';

export function DispatchFeed() {
  const { entries, loading } = useDispatches(6);

  const visible = entries.slice(-50);
  const maxActive = Math.max(...visible.map((e) => e.active_dispatches), 1);

  return (
    <Panel title="Dispatches (6h)" mobilePriority={8}>
      {loading ? (
        <div className="flex justify-center py-4"><Spinner size="sm" /></div>
      ) : visible.length === 0 ? (
        <EmptyState title="No dispatches" description="No dispatch activity in the last 6 hours" />
      ) : (
        <div className="space-y-1 max-h-64 overflow-y-auto">
          {visible.map((e, i) => {
            const barPct = (e.active_dispatches / maxActive) * 100;
            const isActive = e.active_dispatches > 0;
            return (
              <div key={i} className="flex items-center gap-2">
                <span className="text-[10px] text-slate-500 w-14 shrink-0 font-mono">
                  {formatTime(e.timestamp)}
                </span>
                <div className="flex-1 h-3 bg-slate-800/50 rounded-full overflow-hidden">
                  <div
                    className={`h-full rounded-full transition-all ${isActive ? 'bg-slate-500' : 'bg-slate-800'}`}
                    style={{ width: `${barPct}%` }}
                  />
                </div>
                <span className="text-[10px] text-slate-400 font-mono w-6 text-right shrink-0">
                  {e.active_dispatches}
                </span>
                {e.timed_out > 0 && (
                  <span className="text-red-400 font-mono text-[9px] shrink-0">
                    {e.timed_out} TO
                  </span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </Panel>
  );
}
